export const initialConvert = (data) => {
  const result = { ...data };
  Object.keys(result.allProducts).forEach((groupKey) => {
    const groupObject = result.allProducts[groupKey];
    // Ponemos todos los productos visibles.
    groupObject.visible = true;
  });
  return result;
};

const setVisibles = (products) => {
  Object.keys(products).forEach((product) => {
    products[product].visible = true;
  });
};

export const filterProducts = (products, filters) => {
  const myProducts = { ...products };
  setVisibles(myProducts.allProducts);
  Object.keys(myProducts.allProducts).forEach((product) => {
    filters.forEach((filterName) => {
      if (!myProducts.allProducts[product].categories.includes(filterName)) {
        myProducts.allProducts[product].visible = false;
      }
    });
  });
  return products;
};

export const getVisiblesNumber = (products) => {
  let result = 0;
  try {
    Object.keys(products).forEach((product) => {
      if (products[product].visible) {
        result += 1;
      }
    });
  } catch (e) {
    return 0;
  }
  return result;
};

export const selectProduct = (
  valueToSearch,
  group,
  selectedProduct,
  selectorOption
) => {
  const result = { ...group };
  const selectorToSearch = JSON.parse(JSON.stringify(selectedProduct.selector));
  selectorToSearch[selectorOption] = valueToSearch.value;
  // Recorro para poner selected el que coincida.
  Object.keys(result).forEach((product) => {
    if (result[product].selector) {
      if (
        JSON.stringify(result[product].selector)
        === JSON.stringify(selectorToSearch)
      ) {
        result[product].selected = true;
      } else {
        result[product].selected = false;
      }
    }
  });
  return result;
  // Recorremos el group para encontrar el que cumple las condiciones.
};
export const mapToOrderedArray = (map, order) => {
  const result = [];

  let actualMinKey;
  Object.keys(map).forEach((groupKey1, index) => {
    let actualMinPrice = 999;
    Object.keys(map).forEach((groupKey) => {
      if (
        map[groupKey].priceOrder
        && map[groupKey].priceOrder < actualMinPrice
        && !result.includes(groupKey)
      ) {
        actualMinPrice = map[groupKey].priceOrder;
        actualMinKey = groupKey;
      }
    });
    result.push(actualMinKey);
  });
  let orderedArray = [];
  switch (order.value) {
    case '<':
      orderedArray = result;
      break;
    case '>':
      orderedArray = result.reverse();
      break;
    default:
      orderedArray = result;
      break;
  }
  return orderedArray;
};
